import script from "./Nav.vue?vue&type=script&setup=true&lang=ts"
export * from "./Nav.vue?vue&type=script&setup=true&lang=ts"

import "./Nav.vue?vue&type=style&index=0&id=3800a1d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3800a1d2"]])

export default __exports__